import type { ProductImage } from '../types';

export function imageSource(image: ProductImage, width: 720 | 1280 = 720) {
  if (image.url && width === 1280 && image.largeUrl) return image.largeUrl;
  return image.url ?? `/images/fitness/mg-${image.id}-${width}.webp`;
}

export function imageSrcSet(image: ProductImage) {
  if (image.url && image.largeUrl) return `${image.url} 720w, ${image.largeUrl} 1280w`;
  if (image.url) return undefined;
  return `${imageSource(image, 720)} 720w, ${imageSource(image, 1280)} 1280w`;
}
